var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.10346C4.63455 1.10346 1.09565 4.64236 1.09565 9.00781C1.09565 13.3733 4.63455 16.9122 9 16.9122C13.3655 16.9122 16.9044 13.3733 16.9044 9.00781C16.9044 4.64236 13.3655 1.10346 9 1.10346ZM0 9.00781C0 4.03725 4.02944 0.0078125 9 0.0078125C13.9706 0.0078125 18 4.03725 18 9.00781C18 13.9784 13.9706 18.0078 9 18.0078C4.02944 18.0078 0 13.9784 0 9.00781ZM8.99992 4.35099C9.30248 4.35099 9.54775 4.59626 9.54775 4.89882V5.33913C9.54775 5.64169 9.30248 5.88696 8.99992 5.88696C8.69737 5.88696 8.4521 5.64169 8.4521 5.33913V4.89882C8.4521 4.59626 8.69737 4.35099 8.99992 4.35099ZM8.99992 7.96504C9.30248 7.96504 9.54775 8.21031 9.54775 8.51287L9.54775 12.6784C9.54775 12.981 9.30248 13.2262 8.99992 13.2262C8.69737 13.2262 8.4521 12.981 8.4521 12.6784V8.51287C8.4521 8.21032 8.69737 7.96504 8.99992 7.96504Z",
    fill: "#103046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/info-tooltip.e6ea6ff1587e299628787db2700f9b20.svg";
export { ForwardRef as ReactComponent };